export const CHART_COLORS = {
  PENDING: '#FF9900',
  TO_SCHEDULE: '#539FE5',
  SCHEDULED: '#539FE5',
  QUEUED: '#879596',
  PENDING_CLUSTER_PROVISION: '#FF9900',
  IN_PROGRESS: '#7a7aff',
  SUCCESS: '#1D8102',
  FAILED: '#D13212',
  VALIDATION_FAILED: '#D13212',
  ABORTED: '#E0004F',
};

export const STATUS_COLOR_TYPE = {
  PENDING: 'warning',
  TO_SCHEDULE: 'info',
  SCHEDULED: 'info',
  QUEUED: 'pending',
  PENDING_CLUSTER_PROVISION: 'warning',
  IN_PROGRESS: 'in-progress',
  SUCCESS: 'success',
  FAILED: 'error',
  VALIDATION_FAILED: 'error',
  ABORTED: 'error'
};

export const STATUS_OPTIONS = [
  { value: 'SUCCESS', text: 'Success' },
  { value: 'IN_PROGRESS', text: 'In Progress' },
  { value: 'SCHEDULED', text: 'Scheduled' },
  { value: 'PAUSED', text: 'Paused' },
  { value: 'CANCELLED', text: 'Cancelled' },
  { value: 'PENDING', text: 'Pending' },
  { value: 'FAILED', text: 'Failed' }
];
